import React from 'react';
import { Icon, Spin, StatusPill, InvPill, MarginChip, StatusDot,
         Drawer, Modal, Tabs, FG, RG, Pagination } from '../components/ui.jsx';
import { api, fmt, fmtD, dayN } from '../api.js';
import { ROLES, RL, TIPOLOGIE, REGIE, STATUSES, SL, INVOICE, MAT_CAT, MONTHS,
         STATUS_COLORS, INV_COLORS, PAGE_SIZE } from '../constants.js';


export const ClientsPage =()=>{
  const [clients,setClients]=React.useState([]);
  const [modal,setModal]=React.useState(false);
  const [edit,setEdit]=React.useState(null);
  const [f,setF]=React.useState({name:'',contact:'',email:'',phone:''});
  const [sav,setSav]=React.useState(false);
  const [offset,setOffset]=React.useState(0);
  const [total,setTotal]=React.useState(0);
  const load=()=>api(`/clients?limit=${PAGE_SIZE}&offset=${offset}`).then(d=>{setClients(d.items||d);setTotal(d.total||0);}).catch(()=>{});
  React.useEffect(()=>{load()},[offset]);
  const openNew=()=>{setEdit(null);setF({name:'',contact:'',email:'',phone:''});setModal(true);};
  const openEdit=c=>{setEdit(c);setF({name:c.name,contact:c.contact||'',email:c.email||'',phone:c.phone||''});setModal(true);};
  const save=async()=>{
    if(!f.name.trim())return;setSav(true);
    try{
      if(edit)await api(`/clients/${edit.id}`,'PATCH',{name:f.name.trim(),contact:f.contact||null,email:f.email||null,phone:f.phone||null});
      else await api('/clients','POST',{...f,slug:f.name.trim().toLowerCase().replace(/\s+/g,'-').replace(/[^a-z0-9-]/g,''),name:f.name.trim()});
      setModal(false);load();}
    finally{setSav(false);}
  };

  const del_ = async (id, name) => {
    if (!window.confirm('Eliminare "'+ name +'"? Azione irreversibile.')) return;
    try { await api('/clients/'+ id, 'DELETE'); setModal(false); load(); showToast('Eliminato','success'); }
    catch(e) { showToast(e?.body?.detail||'Errore eliminazione','error'); }
  };
  return(
    <div>
      <div className="page-header">
        <div className="page-title">Clienti</div>
        <button className="btn btn-primary" onClick={openNew}><Icon name="plus" size={14} color="#fff"/>Nuovo</button>
      </div>
      <div className="card" style={{padding:0}}>
        <table>
          <thead><tr><th>Nome</th><th>Referente</th><th>Email</th><th>Telefono</th><th></th></tr></thead>
          <tbody>
            {clients.map(c=>(
              <tr key={c.id}>
                <td style={{fontWeight:600}}>{c.name}</td>
                <td style={{color:'var(--n400)',fontSize:12}}>{c.contact||'-'}</td>
                <td style={{fontSize:12}}>{c.email||'-'}</td>
                <td style={{fontSize:12}}>{c.phone||'-'}</td>
                <td style={{textAlign:'right'}}>
                  <button className="btn btn-ghost btn-sm" style={{padding:'5px 7px'}} onClick={()=>openEdit(c)}>
                    <Icon name="pencil" size={13} color="var(--n500)"/></button>
                </td>
              </tr>
            ))}
            {!clients.length&&<tr><td colSpan={5} className="empty">Nessun cliente</td></tr>}
          </tbody>
        </table>
      </div>
      {modal&&(
        <Modal title={edit?`Modifica - ${edit.name}`:'Nuovo cliente'} onClose={()=>setModal(false)}>
          <div className="grid grid-2">
            <FG label="Nome / Organizzazione *" span={2}>
              <input autoFocus className="input" value={f.name} onChange={e=>setF(p=>({...p,name:e.target.value}))}/></FG>
            <FG label="Referente" span={2}>
              <input className="input" value={f.contact} onChange={e=>setF(p=>({...p,contact:e.target.value}))}/></FG>
            <FG label="Email"><input type="email" className="input" value={f.email} onChange={e=>setF(p=>({...p,email:e.target.value}))}/></FG>
            <FG label="Telefono"><input className="input" value={f.phone} onChange={e=>setF(p=>({...p,phone:e.target.value}))}/></FG>
          </div>
          <div style={{display:'flex',justifyContent:edit?'space-between':'flex-end',gap:8,marginTop:12}}>
            {edit && <button className="btn" style={{background:'var(--danger)',color:'#fff'}} onClick={()=>del_(edit.id,edit.name)}>
              <Icon name="trash-2" size={13} color="#fff"/>Elimina</button>}
            <div style={{display:'flex',gap:8}}>
              <button className="btn btn-ghost" onClick={()=>setModal(false)}>Annulla</button>
              <button className="btn btn-primary" onClick={save} disabled={sav}>
                <Icon name="save" size={13} color="#fff"/>{sav?'Salvataggio...':'Salva'}</button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

